import { useCallback, useEffect, useState } from "react";
import { InvoiceSubscriptionService } from "../services/InvoiceSubscriptionService";

export const useHookInvoiceSubscription = () => {
    const [data, setData] = useState([]);
    const [meta, setMeta] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [params, setParams] = useState({
        search: "",
        type: "", 
        category_id: "",
        metode: "",       // ✅ DITAMBAH
        sort: "",         // ✅ DITAMBAH
        page: 1,
        per_page: 10,
    });

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            // ✅ Hanya kirim param yang punya value (skip kosong)
            const cleanParams = Object.fromEntries(
                Object.entries(params).filter(([_, v]) => v !== "")
            );

            const res = await InvoiceSubscriptionService.get({ params: cleanParams });

            const result = res?.data?.data ?? [];
            const responseMeta = res?.data?.meta ?? res?.data?.links ?? null;

            setData(Array.isArray(result) ? result : []);
            setMeta(responseMeta);
        } catch (err) {
            console.error("Fetch Transaction Error:", err);
            setError(err?.response?.data || err);
        } finally {
            setLoading(false);
        }
    }, [JSON.stringify(params)]);

    useEffect(() => {
        getData();
    }, [getData]);

    const updateParams = (newParams) => {
        setParams((prev) => ({
            ...prev,
            ...newParams,
        }));
    };

    // ✅ Helper khusus reset semua filter ke default
    const resetParams = () => {
        setParams({
            search: "",
            type: "", 
            category_id: "",
            metode: "",
            sort: "",
            page: 1,
            per_page: 10,
        });
    };

    return {
        data,
        meta,
        loading,
        error,
        params,
        setParams,
        updateParams,
        resetParams,      // ✅ DITAMBAH
        refreshData: getData,
    };
};